import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { SubscriptionListenerComponent } from '../../angular-wallet-base/SubscriptionListenerComponent';
import { Store } from '@ngrx/store';
import { AppState } from '../../angular-wallet-base/store/appState';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { AppModeService } from '../../angular-wallet-base/services/app-mode.service';

@Component({
  selector: 'wire-transfer-success-modal-token',
  templateUrl: './wire-transfer-success-modal.component.html',
  styleUrls: ['./wire-transfer-success-modal.component.scss'],
})
export class WireTransferSuccessModalComponent extends SubscriptionListenerComponent implements OnInit {
  @Input() newBalance: number;
  @Input() epinBalance: number;
  @Input() tokenSymbol: string;
  @Input() tokenGuid: any;
  @Input() baseChainSymbol: string;
  @Input() logo: string;
  @Input() wireDetail: any;
  @Input() orderNumber: number;
  @Input() quote: any;
  @Input() usdAmount: number;
  @Input() currency: string;
  public isDesktopMode;

  constructor(private activatedRoute: ActivatedRoute,
              protected store: Store<AppState>,
              private nav: NavController,
              private modal: ModalController,
              private appMode: AppModeService,
              private modalController: ModalController,
              private elementRef: ElementRef,
              private iab: InAppBrowser) {
    super(store);
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  async ngOnInit() {}

  goToAssets() {
    this.modal.dismiss();
    this.nav.navigateForward(['/wallet/assets']);
  }

  onBack()
  {
    this.modal.dismiss({});
  }
  
  async viewWireModal(type) {
    let pdfUrl;

    if (type === 'wire') {
      pdfUrl = 'https://members.lode.one/pdfs/bank_wire_instructions_september_2021.pdf';
    } else if (type === 'sepa') {
      pdfUrl = 'https://members.lode.one/pdfs/SEPA.pdf';
    }

    this.iab.create(pdfUrl, '_system', 'location=yes');
  }
}
